const grillaSolicitudesState = {
  modalVerDetalle: false,
  idSolicitudDetalle: 0,
  loadingFile: false,
};

export default grillaSolicitudesState;



// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/GrillaSolicitudes/state.js